import "./ShowRegistrationGroup.css";

import { Breadcrumb, Button, message, Tag } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteRegistrationGroup, useAppSelector } from "../../../_lib/_store";

export const ShowRegistrationGroupPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.registrationGroup);

  const navigate = useNavigate();
  const { state } = useLocation();

  const registrationGroupObj = state?.registrationGroup;

  const handleDelete = async () => {
    const res = await deleteRegistrationGroup(
      messageApi,
      registrationGroupObj?.id,
    );
    if (res) {
      navigate("/registration-group");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/registration-group">Registration Group</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/registration-group/edit`, {
                  state: { registrationGroup: state?.registrationGroup },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{registrationGroupObj?.name}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{registrationGroupObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Tags</p>
            {/* <div className="tagBox">{registrationGroupObj?.tags?.map((v)=> v?.name).join(",")}</div> */}
          </div>
          <div className="row">
            <p className="label">Packages</p>
            {/* <div className="tagBox">{registrationGroupObj?.packages?.map((v)=> v?.name).join(",")}</div> */}
          </div>
          <div className="row">
            <p className="label">Registration No</p>
            <p className="value">{registrationGroupObj?.registrationNo}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{registrationGroupObj?.description}</p>
          </div>
          <div className="row">
            <p className="label">Audit Type</p>
            <Tag>{registrationGroupObj?.auditType}</Tag>
          </div>
          <div className="row">
            <p className="label">Personal Notes</p>
            <p className="value">{registrationGroupObj?.personalNotes}</p>
          </div>
          <div className="row">
            <p className="label">Risk Level</p>
            <Tag>{registrationGroupObj?.riskLevel}</Tag>
          </div>
          <div className="row">
            <p className="label">Ndis Standards Modules</p>
            <p className="value">
              {registrationGroupObj?.ndisStandardsModules}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
